const t = { last_updated: "Päivitetty viimeksi", Series_type: "Sarja", "How to guide_type": "Opas", FAQ_type: "Oletusarvo" }, e = {
  articles: t
};
export {
  t as articles,
  e as default
};
//# sourceMappingURL=help-center-knowledge-anatomies38.js.map
